// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.select-file-wdth {
  width: 190px;
}

.m-top-14 {
  margin-top: 14px;
}

.w-190 {
  width: 190px;
}

.w-150 {
  width: 150px;
}

.w-220 {
  width: 220px;
}

.display-none {
  display: none;
}

label.label input[type="file"] {
  position: absolute;
  top: -1000px;
}

.label {
  box-shadow: 6px 6px 9px #b6bfbf, -6px -6px 9px #edfbfafa !important;
  border-radius: 4px !important;
  font-size: 14px !important;
  text-align: center !important;
  cursor: pointer !important;
  -webkit-user-select: none !important;
          user-select: none !important;
  font-family: myfont !important;
  color: #ffffff !important;
  background-color: #001489 !important;
  border-color: #001489 !important;
  padding: 10px 15px;
}

.label:hover {
  box-shadow: 9px 9px 16px #919a9c, -9px -9px 16px #ffffff !important;
  border: 1px solid #0068b3 !important;
  color: #ffcc00 !important;
}

.label:active {
  background: #9fa1a0;
}

.label:invalid + span {
  color: #000000;
}

.label:valid + span {
  color: #ffffff;
}

.w-14-em {
  width: 14em;
}

.w-12-em {
  width: 12em;
}
`, "",{"version":3,"sources":["webpack://./src/components/import/styles/ImportForm.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,mEAAmE;EACnE,6BAA6B;EAC7B,0BAA0B;EAC1B,6BAA6B;EAC7B,0BAA0B;EAC1B,oCAA4B;UAA5B,4BAA4B;EAC5B,8BAA8B;EAC9B,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,mEAAmE;EACnE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb","sourcesContent":[".select-file-wdth {\n  width: 190px;\n}\n\n.m-top-14 {\n  margin-top: 14px;\n}\n\n.w-190 {\n  width: 190px;\n}\n\n.w-150 {\n  width: 150px;\n}\n\n.w-220 {\n  width: 220px;\n}\n\n.display-none {\n  display: none;\n}\n\nlabel.label input[type=\"file\"] {\n  position: absolute;\n  top: -1000px;\n}\n\n.label {\n  box-shadow: 6px 6px 9px #b6bfbf, -6px -6px 9px #edfbfafa !important;\n  border-radius: 4px !important;\n  font-size: 14px !important;\n  text-align: center !important;\n  cursor: pointer !important;\n  user-select: none !important;\n  font-family: myfont !important;\n  color: #ffffff !important;\n  background-color: #001489 !important;\n  border-color: #001489 !important;\n  padding: 10px 15px;\n}\n\n.label:hover {\n  box-shadow: 9px 9px 16px #919a9c, -9px -9px 16px #ffffff !important;\n  border: 1px solid #0068b3 !important;\n  color: #ffcc00 !important;\n}\n\n.label:active {\n  background: #9fa1a0;\n}\n\n.label:invalid + span {\n  color: #000000;\n}\n\n.label:valid + span {\n  color: #ffffff;\n}\n\n.w-14-em {\n  width: 14em;\n}\n\n.w-12-em {\n  width: 12em;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
